import { useEffect, useState } from "react";
import { IError } from "flowy-3-core";
import { Button, Modal, Typography } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";

type WarningModal = {
  errors: IError[];
};

const { Text } = Typography;

const ErrorModal = ({ errors }: WarningModal) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (errors.length > 0) {
      setVisible(true);
    }
  }, [errors]);

  return (
    <div>
      {errors.length > 0 && (
        <Modal
          open={visible}
          title={
            <div>
              <CloseCircleFilled style={{ color: "red" }} /> Error
            </div>
          }
          footer={[
            <Button
              style={{ backgroundColor: "#AB0A3D", color: "white" }}
              onClick={() => setVisible(false)}
            >
              Aceptar
            </Button>,
          ]}
          style={{ top: 20 }}
        >
          {errors.length > 0 &&
            errors.map((error: IError) => (
              <span key={error.fid}>
                <Text>{error.message}</Text>
                <br />
              </span>
            ))}
        </Modal>
      )}
    </div>
  );
};

export default ErrorModal;
